import styled from 'styled-components';
import Colors from 'assets/Colors';

const PageContainer = styled.div`
  width: 97%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  /* max-width: 1136px; */
`;

const Container = styled.div`
  display: grid;
  grid-template-columns: 5fr 3fr;
  gap: 0 30px;
  width: 100%;
  overflow: visible;
  background: ${Colors.background_secondary};
  border-radius: 4px;
  max-width: 100vw;
  @media (max-width: 1390px) {
    grid-template-columns: 1fr;
  }
`;

const Title = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  display: flex;
  align-items: center;
  background: ${Colors.BG_Header_Card};
  padding-left: 17px;
  width: 100%;
  height: 42px;
  color: ${Colors.text_on_primary};
`;

const items = styled.div`
  display: flex;
  justify-content: space-between;

  gap: 20px;
  width: 100%;
`;

const BodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 17px;
`;

const ChartComponentsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 300px;
  @media (max-width: 1390px) {
    flex-direction: column;
  }
`;

const Line = styled.div`
  background: ${Colors.divider};
  height: 1px;
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;
  :last-child {
    display: none;
  }
`;

const text = styled.div`
  font-size: 12px;
  font-weight: 300;
  line-height: 21px;
  color: ${Colors.text_primary};
`;

const textDate = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: ${Colors.text_primary};
`;
const textLight = styled.div`
  margin-top: -31px;
  font-size: 12px;
  font-weight: 300;
  color: ${Colors.text_secondary};
`;

const NoItemsContainer = styled.div`
  height: 144px;
  display: grid;
  align-items: center;
`;

const NoItemsMessageCenter = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  color: ${Colors.text_secondary};
  font-weight: 500;
  font-size: 12px;
  line-height: 21px;
`;

export default {
  textDate,
  Container,
  textLight,
  Title,
  items,
  PageContainer,
  Line,
  text,
  BodyContainer,
  ChartComponentsWrapper,
  NoItemsContainer,
  NoItemsMessageCenter,
};
